class CapApproveOneTimeRide {
  constructor(config) {
    this.config = config
  }

  checkPermission() {
    return Boolean(this.config)
  }
}

function key() {
  return 'approve_one_time_ride'
}

function create(config) {
  return new CapApproveOneTimeRide(config)
}

export default {
  key,
  create,
}
